import { loadScript } from './load-script';

export function loadFacebookSdk () {
    return new Promise(function (resolve, reject) {
        loadScript('https://connect.facebook.net/en_US/sdk.js').then(() => {
            FB.init({
                appId            : '412708662147388',
                autoLogAppEvents : true,
                xfbml            : true,
                version          : 'v6.0'
            });
            resolve(true);
        });
    });
}

export function loadAppleSdk () {
    return new Promise(function (resolve, reject) {
        loadScript('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js').then(() => {
            AppleID.auth.init({
                clientId : 'com.puma.pumatrac',
                scope : 'name email',
                redirectURI : location.origin + '/login',
                state : '[STATE]',
                usePopup : true
            });
            resolve(true);
        });
    });
}
